export const OPENED_APP_FRAGMENT_IDENTIFIER = 'openedApp';
